<template>
  <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.1501 8.99983C17.1501 9.63495 16.6352 10.1498 16.0001 10.1498H2.0001C1.36497 10.1498 0.850098 9.63495 0.850098 8.99983C0.850098 8.3647 1.36497 7.84983 2.0001 7.84983H16.0001C16.6352 7.84983 17.1501 8.3647 17.1501 8.99983Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.93647 17.15C8.30134 17.15 7.78647 16.6351 7.78647 16V1.99998C7.78647 1.36485 8.30134 0.849976 8.93647 0.849976C9.5716 0.849976 10.0865 1.36485 10.0865 1.99998V16C10.0865 16.6351 9.5716 17.15 8.93647 17.15Z"
      fill="white"
    />
  </svg>
</template>

<script>
export default {}
</script>
